import GeneralSummaryCard from "@/components/overview/generalSummaryCard";

import { StoreIcon } from "lucide-react";
import { useTranslation } from "react-i18next";

const SummaryCard = ({
  title,
  value,
  description,
  icon = StoreIcon,
  isCurrency = false,
  trend = null,
}) => {
  const { t } = useTranslation();
  const renderTrend = () => {
    if (!trend) return null;

    const { percentage, isPositive } = trend;
    const trendColor = isPositive ? "text-green-600" : "text-red-600";
    const trendSuffix = t(
      "extendedWarranty.reports.summary.trendSuffix",
      "önceki döneme göre",
    );

    return (
      <p className={`mt-1 text-xs font-medium ${trendColor}`}>
        {isPositive ? "+" : ""}
        {percentage}% {trendSuffix}
      </p>
    );
  };

  return (
    <GeneralSummaryCard>
      <GeneralSummaryCard.Content icon={icon}>
        <div>
          <p className="text-2xl font-semibold text-[#111729]">
            {isCurrency ? "₺" : ""}
            {value?.toLocaleString() || "0"}
          </p>
          <p className="text-sm text-[#677389]">{title}</p>
          {renderTrend()}
          {!trend && description && (
            <p className="mt-1 text-xs text-[#677389]">{description}</p>
          )}
        </div>
      </GeneralSummaryCard.Content>
    </GeneralSummaryCard>
  );
};

export default SummaryCard;
